if (!customElements.get('gerlak-christmas')) {
  customElements.define('gerlak-christmas', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.labels = JSON.parse(this.querySelector('[data-gcm-labels]').textContent);
      this.form = this.querySelector('.gcm-form');
      this.idInput = this.querySelector('[data-gcm-id]');
      this.button = this.querySelector('[data-gcm-submit]');
      this.status = this.querySelector('[data-gcm-status]');
      this.picks = {fn: [], xm: []};

      let tab = this.dataset.initTab || 'xm';
      const params = new URLSearchParams(location.search);
      const k = (params.get('kolekcja') || '').toLowerCase();
      if (!params.get('variant') && k.startsWith('swi')) tab = 'xm';
      if (!params.get('variant') && k.startsWith('rel')) tab = 'fn';
      this.tab = tab;

      const initPick = this.dataset.initPick;
      if (initPick) {
        const btn = this.querySelector('.gcm-pick[data-id="' + initPick + '"]');
        if (btn) this.picks[btn.closest('[data-panel]').dataset.panel] = [initPick];
      }
      this.querySelectorAll('[data-panel]').forEach(panel => {
        if (!panel.querySelector('input[type=radio]:checked')) {
          const first = panel.querySelector('input[type=radio]');
          if (first) first.checked = true;
        }
      });

      this.addEventListener('click', event => {
        const tabBtn = event.target.closest('[data-tab]');
        if (tabBtn) { this.tab = tabBtn.dataset.tab; this.update(true); return; }
        const up = event.target.closest('[data-upsell]');
        if (up) {
          const setInput = this.panel().querySelector('input[type=radio][value="set"]');
          if (setInput) { setInput.checked = true; this.update(true); setInput.closest('.gcm-offer').scrollIntoView({behavior: 'smooth', block: 'center'}); }
          return;
        }
        const pick = event.target.closest('.gcm-pick');
        if (pick && !pick.disabled) this.togglePick(pick);
      }, {signal});
      this.addEventListener('change', event => {
        if (event.target.matches('.gcm-offer input')) this.update(true);
      }, {signal});
      this.form.addEventListener('submit', event => this.submit(event), {signal});

      this.update(false);
      this.eta();

      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.querySelector('[data-gcm-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.observer.observe(this.form);
    }
    panel() { return this.querySelector('[data-panel="' + this.tab + '"]'); }
    offer() { const p = this.panel(); return p ? p.querySelector('input[type=radio]:checked') : null; }
    need() { const o = this.offer(); return Number(o ? o.dataset.need : 0); }
    togglePick(btn) {
      const need = this.need();
      if (!need) return;
      const list = this.picks[this.tab];
      const id = btn.dataset.id;
      const i = list.indexOf(id);
      if (i > -1) list.splice(i, 1);
      else {
        if (need === 1) list.length = 0;
        else if (list.length >= need) list.shift();
        list.push(id);
      }
      if (btn.dataset.image) this.setImage(btn.dataset.image, btn.dataset.title);
      this.update(true);
    }
    setImage(src, alt) {
      const image = this.querySelector('.gcm-main-image');
      if (!image || !src) return;
      image.removeAttribute('srcset');
      image.src = src;
      image.alt = alt || '';
    }
    update(updateUrl) {
      this.querySelectorAll('[data-tab]').forEach(b => b.setAttribute('aria-selected', String(b.dataset.tab === this.tab)));
      this.querySelectorAll('[data-panel]').forEach(p => { p.hidden = p.dataset.panel !== this.tab; });
      this.querySelectorAll('.gcm-offer').forEach(l => { const inp = l.querySelector('input'); l.classList.toggle('is-checked', !!(inp && inp.checked)); });
      const panel = this.panel();
      const offer = this.offer();
      if (!panel || !offer) return;
      const need = this.need();
      const list = this.picks[this.tab];
      while (list.length > need) list.shift();

      const picker = panel.querySelector('[data-picker]');
      picker.hidden = need === 0;
      panel.querySelectorAll('[data-upsell]').forEach(b => { b.hidden = need === 0; });
      panel.querySelectorAll('.gcm-pick').forEach(b => b.setAttribute('aria-pressed', String(list.includes(b.dataset.id))));
      panel.querySelector('[data-need-label]').textContent = need === 3 ? '3 wzory' : 'wzór';
      panel.querySelector('[data-count]').textContent = need > 1 ? (list.length + '/' + need) : '';

      if (need === 0 && offer.dataset.image) this.setImage(offer.dataset.image, offer.dataset.title);

      this.querySelectorAll('[data-gcm-price]').forEach(n => { n.textContent = offer.dataset.price; });
      this.querySelector('[data-gcm-compare]').textContent = offer.dataset.compare || '';
      let title = offer.dataset.title;
      if (need === 1 && list.length) {
        const picked = panel.querySelector('.gcm-pick[data-id="' + list[0] + '"]');
        if (picked) title = picked.dataset.title;
      }
      this.querySelector('[data-gcm-sticky-title]').textContent = title;

      const ready = need === 0 || list.length === need;
      this.button.disabled = !ready;
      if (ready) {
        this.button.textContent = offer.dataset.cta + ' – ' + offer.dataset.price;
      } else {
        const left = need - list.length;
        this.button.textContent = need === 1 ? 'Wybierz wzór powyżej' : ('Wybierz jeszcze ' + left + ' ' + (left === 1 ? 'wzór' : 'wzory'));
      }
      this.status.textContent = '';
      this.idInput.value = need === 0 ? offer.dataset.variant : ((need === 1 && list[0]) || '');

      if (updateUrl) {
        const url = new URL(location.href);
        if (this.idInput.value) url.searchParams.set('variant', this.idInput.value);
        else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      const need = this.need();
      const list = this.picks[this.tab];
      if (need > 0 && list.length !== need) {
        const picker = this.panel().querySelector('[data-picker]');
        picker.classList.remove('is-shake'); void picker.offsetWidth; picker.classList.add('is-shake');
        picker.scrollIntoView({behavior: 'smooth', block: 'center'});
        return;
      }
      const ids = need === 0 ? [this.idInput.value] : list.slice();
      if (!ids.length || !ids[0]) { this.status.textContent = this.labels.unavailableNote; return; }

      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = 'Dodawanie…';
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const drawer = document.querySelector('cart-drawer');
      const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
      let errorText = '';
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({
            items: ids.map(id => ({id: Number(id), quantity: 1})),
            sections: sectionIds.join(','),
            sections_url: location.pathname
          })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.status) { errorText = data.description || this.labels.error; return; }

        if (!drawer || typeof drawer.renderContents !== 'function') { location.href = root + 'cart'; return; }
        if (!data.sections || !data.sections['cart-drawer']) {
          data.sections = await fetch(root + '?sections=' + sectionIds.join(',')).then(r => r.json());
        }
        try {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } catch (renderError) {
          console.error(renderError);
          location.href = root + 'cart';
          return;
        }
        try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, {source: 'gerlak-molds'}); } catch (e) {}
      } catch (e) {
        console.error(e);
        errorText = this.labels.error;
      } finally {
        this.busy = false;
        this.update(false);
        if (errorText) this.status.textContent = errorText;
      }
    }
    eta() {
      const fmt = new Intl.DateTimeFormat('pl-PL', {day: 'numeric', month: 'short'});
      const add = n => { const d = new Date(); let a = 0; while (a < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; };
      const range = (a, b) => fmt.format(add(a)) + ' – ' + fmt.format(add(b));
      const ship = this.querySelector('[data-eta-ship]');
      const del = this.querySelector('[data-eta-deliver]');
      if (ship) ship.textContent = range(1, 2);
      if (del) del.textContent = range(5, 8);
      const now = new Date();
      const cutoff = new Date(now.getFullYear(), 11, 10, 23, 59);
      const cut = this.querySelector('[data-gcm-cutoff]');
      if (cut && (now > cutoff || now.getMonth() < 9)) cut.hidden = true;
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.observer) this.observer.disconnect();
      this.ready = false;
    }
  });
}
